import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgChevronLeft({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.296 11.293l5.997-6a1 1 0 011.414 1.414L9.417 12l5.29 5.293a1 1 0 01-1.414 1.414l-5.997-6a1 1 0 010-1.414z"
        fill={color}
      />
    </svg>
  )
}

export default SvgChevronLeft
